
/**
 * @export
 * @enum {string}
 */
export enum ProductSubscriptionCapacityStatus {
    WITHIN_CAPACITY = 'WITHIN_CAPACITY',
    OVER_CAPACITY = 'OVER_CAPACITY'
}